export default Object.freeze({
  ProcessIdentifier: 1,
  ProcessName: 2,
  ProcessGroupName: 3,
  InstanceName: 4,
  InstanceCreated: 5,
  InstanceStatus: 6,
  ApplicantFullName: 7,
  InstanceApprovedDate: 8,
  InstanceRejectedDate: 9,
  ApplicantNames: 10,
  ApplicantLastNames: 11,
  ApplicantEmail: 12,
  ApplicantPosition: 13,
  InstanceIdentifier: 14,
  InstanceLastInstanceRejectUsers: 15,
  InstanceLastInstanceApproversUsers: 16,
  InstanceRejectedReason: 17,
  InstanceApprovalRemarks: 18,
  InstanceCancellationDate: 19,
  InstanceCancellationReason: 20,
  InstanceDetailsViewUrl: 21,
});
